import styles from './mileage_history.module.scss';
import React from 'react';

interface OwnProps {
    children: React.ReactNode;
}

export function MileageHistory({children}: OwnProps) {
    return <div className={styles.mileage_history}>{children}</div>;
}
